import { ErrorTypes } from '@wix/form-validator';
import { deserializeDate } from '../date-picker/helpers';
import { DerivedErrorTypes } from '../../field-error/error-types';
import { SupportedDateParts } from '../../utils/date-format-parts';
export let DateFieldErrorSuffix = /*#__PURE__*/function (DateFieldErrorSuffix) {
  DateFieldErrorSuffix["YEAR_MONTH"] = "year-month";
  DateFieldErrorSuffix["YEAR_DAY"] = "year-day";
  DateFieldErrorSuffix["MONTH_DAY"] = "month-day";
  DateFieldErrorSuffix["YEAR"] = "year";
  DateFieldErrorSuffix["MONTH"] = "month";
  DateFieldErrorSuffix["DAY"] = "day";
  return DateFieldErrorSuffix;
}({});
export const getDateFieldError = (_validation, error, value) => {
  const isFormatError = (error == null ? void 0 : error.errorType) === ErrorTypes.FORMAT_ERROR;
  if (!error || !isFormatError) {
    return error;
  }
  const {
    YEAR: _YEAR,
    MONTH,
    DAY
  } = deserializeDate(value);
  const YEAR = (_YEAR == null ? void 0 : _YEAR.length) === 4;

  // All missing is the error we got as input
  if (!YEAR && !MONTH && !DAY) {
    return error;
  }
  const withErrorSuffix = suffix => ({
    ...error,
    errorType: DerivedErrorTypes.INCOMPLETE_DATE_ERROR,
    params: {
      suffix
    }
  });
  if (!YEAR && !MONTH) {
    return withErrorSuffix(DateFieldErrorSuffix.YEAR_MONTH);
  }
  if (!YEAR && !DAY) {
    return withErrorSuffix(DateFieldErrorSuffix.YEAR_DAY);
  }
  if (!MONTH && !DAY) {
    return withErrorSuffix(DateFieldErrorSuffix.MONTH_DAY);
  }
  if (!YEAR) {
    return withErrorSuffix(DateFieldErrorSuffix.YEAR);
  }
  if (!MONTH) {
    return withErrorSuffix(DateFieldErrorSuffix.MONTH);
  }
  if (!DAY) {
    return withErrorSuffix(DateFieldErrorSuffix.DAY);
  }
  return error;
};
export const getDatePartsErrors = (hasError, value) => {
  const {
    YEAR,
    MONTH,
    DAY
  } = deserializeDate(value);
  const invalidParts = [(YEAR == null ? void 0 : YEAR.length) !== 4, !MONTH, !DAY];
  const allValidParts = !invalidParts.some(Boolean);
  return {
    [SupportedDateParts.YEAR]: hasError && (allValidParts || invalidParts[0]),
    [SupportedDateParts.MONTH]: hasError && (allValidParts || invalidParts[1]),
    [SupportedDateParts.DAY]: hasError && (allValidParts || invalidParts[2])
  };
};
export const getDateValidationErrorSuffix = error => {
  var _error$params;
  return (error == null ? void 0 : error.errorType) === DerivedErrorTypes.INCOMPLETE_DATE_ERROR ? error == null || (_error$params = error.params) == null ? void 0 : _error$params.suffix : undefined;
};
//# sourceMappingURL=date-field-utils.js.map